import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-add-data-extract',
  templateUrl: './add-data-extract.component.html',
  styleUrls: ['./add-data-extract.component.scss']
})
export class AddDataExtractComponent implements OnInit {
  public iframeUrl: any = null;
  constructor(public sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(environment.extractToView.url + "App_config/dcDataExport.aspx");
  }
  back(){
     this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(environment.extractToView.url + "App_config/dcDataExport.aspx");
  }
}
